import { iEquoboxMediumKeyValue } from "./../../../model/interface/iEquoboxMediumKeyValue";
import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Device } from "src/components/shared-components/class/general-classes/device";

import { StaticClass } from "src/components/shared-components/class/general-classes/static-classes";
import { EquoboxMedium } from "src/components/shared-components/enum/enumEquobox";
import { GatewayKind } from "src/components/shared-components/enum/enumGateway";
import { iDevicesKnown } from "src/model/interface/iDevicesKnown";

@Component({
    selector: "app-edit-sinapsi-device-known",
    templateUrl: "./edit-sinapsi-known-device.html",
    styleUrls: ["./edit-sinapsi-known-device.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditSinapsiKnownDeviceComponent implements OnInit {
  public formEditSinapsiDevice: UntypedFormGroup = null;
  public isEquoboxUnknown: boolean = false;
  public isGatewayKindEqualSinapsi: boolean = false;
  public equoboxMediumkeysNameArray: Array<iEquoboxMediumKeyValue> = [];

  @Input() clickedSinapsiDeviceToEdit: Device;
  @Input() clickedAssociatedKnownDevice: iDevicesKnown;
  @Input() okText: string;
  @Input() closeText: string;

  constructor(private _fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.checkDeviceTypeConditions();
    this.initializeEditSinapsiDeviceForm();
    this.equoboxMediumkeysNameArray = this.transformEquoboxValuesArray(
      Object.values(EquoboxMedium)
    ).filter((equoboxMedium) => equoboxMedium !== null);
  }

  /**
   * Handle the submission of the edited Sinapsi Device
   * @returns
   */
  public onSubmitFormEditSinapsiKnownDevice() {
    this.formEditSinapsiDevice.get("deviceType").enable();
    return this.formEditSinapsiDevice;
  }
  /**
   * Checks the conditions required to show an error message
   * @param formControlToCheck the formControlName
   * @returns
   */
  public checkConditionsToShowErrorMessage(
    formControlToCheck: string = ""
  ): boolean {
    if (
      formControlToCheck === undefined ||
      formControlToCheck === "" ||
      formControlToCheck === null
    ) {
      return false;
    }

    const targetFormControl: AbstractControl =
      this.formEditSinapsiDevice.get(formControlToCheck);

    return !!(
      targetFormControl &&
      targetFormControl.touched &&
      targetFormControl.invalid
    );
  }
  /**
   * Initialze the formEditSinapsiDevice and set the inital/default values
   */
  private initializeEditSinapsiDeviceForm(): void {
    const defaultValues = {
      description: ["", Validators.required],
      physicalAddress: { value: "", disabled: true },
      deviceType: "",
    };
    this.formEditSinapsiDevice = this._fb.group(defaultValues);
    if (this.clickedSinapsiDeviceToEdit !== null) {
      this.formEditSinapsiDevice.patchValue({
        description: this.clickedSinapsiDeviceToEdit.description,
        physicalAddress: this.clickedSinapsiDeviceToEdit.physicalAddress,
      });
    }

    if (this.clickedAssociatedKnownDevice !== null) {
      this.formEditSinapsiDevice.patchValue({
        deviceType: this.clickedAssociatedKnownDevice.orderNumber1,
      });
    }

    this.deviceTypeFormSelectFieldMode();
  }

  /**
   * Check deviceType conditions: If the device has a gateway type of Sinapsi and Equobox value equal to the device orderNumber1
   */
  private checkDeviceTypeConditions(): void {
    if (this.clickedSinapsiDeviceToEdit?.gatewayKind === GatewayKind.SINAPSI) {
      this.isGatewayKindEqualSinapsi = true;
    }
    if (
      this.clickedAssociatedKnownDevice?.orderNumber1 ===
      EquoboxMedium.EQUOBOX_MEDIUM_HEAT_UNKNOWN_MEDIUM
    ) {
      this.isEquoboxUnknown = true;
    }
  }

  /**
   * Handle the mode of the deviceType form filed: if enable or disable
   */
  private deviceTypeFormSelectFieldMode(): void {
    this.formEditSinapsiDevice.get("deviceType").disable();

    if (this.isEquoboxUnknown && this.isGatewayKindEqualSinapsi) {
      this.formEditSinapsiDevice.get("deviceType").enable();
    }
  }

  /**
   * Transforms the enum equoboxMedium keys array into an object array conataining the require keys and value of the EquoBox enum
   * @param equoboxMediumKeysArray array of EquoboxMedium values
   * @returns object array containing the EquoboxMesium keys and values
   */
  private transformEquoboxValuesArray(
    equoboxMediumKeysArray: Array<EquoboxMedium>
  ): Array<iEquoboxMediumKeyValue> {
    return equoboxMediumKeysArray.map((enumEquoboxMediumValue) => {
      const equoboxMediumKeyLabel: string =
        StaticClass.getEquoboxMediumKeyLabel(enumEquoboxMediumValue);

      const trasnformedEquoboxMediumData: iEquoboxMediumKeyValue = {
        key: equoboxMediumKeyLabel,
        value: enumEquoboxMediumValue,
      };

      return trasnformedEquoboxMediumData;
    });
  }
}
